<template>
  <div style="display: flex;" ref="popoverAnchor">
    <Button text size="small" style="flex-grow: 1; justify-content: center; gap: 10px; color: #333;" @click="togglePopover()">
      <div style="flex-grow: 1; flex-basis: 0;"></div>
      <div style="font-size: 17px;">
        {{ bin.name.value }}
      </div>
      <div style="flex-grow: 1; flex-basis: 0; display: flex; justify-content: flex-start;">
        <i class="pi pi-cog"></i>
      </div>
    </Button>
    <Popover v-model:showingPopover="showingPopover" :popoverAnchor="popoverAnchor">
      <div style="display: flex; flex-direction: column; gap: 10px; padding: 10px;">
        <InputText ref="textInput" style="text-align: center; font-size: large;"
          :modelValue="bin.name.value"
          @update:modelValue="value => setBinName(value)"
          @keypress.enter="showingPopover = false"
        ></InputText>
        <div style="display: flex; gap: 10px;">
          <Button severity="secondary" style="flex-grow: 1; flex-basis: 0; justify-content: center;" @click="cloneBin()">
            Clone
          </Button>
          <Button severity="danger" style="flex-grow: 1; flex-basis: 0; justify-content: center;" @click="deleteBin()">
            Delete
          </Button>
          <!-- <Button style="flex-grow: 1; flex-basis: 0; justify-content: center;">
            Ok
          </Button>
          <Button severity="secondary" style="flex-grow: 1; flex-basis: 0; justify-content: center;">
            Cancel
          </Button> -->
        </div>
      </div>
    </Popover>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { promiseTimeout } from "@vueuse/core";
import { showSubmit, systemCopy } from "./ChannelAssignments.vue";
import Popover from "./Popover.vue";

let props = defineProps([
  "bin"
]);

let textInput = ref();
let popoverAnchor = ref();
let showingPopover = ref(false);
async function togglePopover() {
  showingPopover.value = !showingPopover.value;
  if (showingPopover.value) {
    await promiseTimeout();
    textInput.value.$el.select();
  }
}

function setBinName(value) {
  props.bin.name.value = value;
  showSubmit.value = true;
}

function cloneBin() {
  let binsTag = systemCopy.value.bins;
  let newBin = props.bin.$clone();
  newBin.name.value = `Bin ${binsTag.children.length + 1}`;
  binsTag.children.push(newBin);
  showSubmit.value = true;
}

function deleteBin() {
  systemCopy.value.bins.children = systemCopy.value.bins.children.filter(bin => bin != props.bin);
  showingPopover.value = false;
  showSubmit.value = true;
}
</script>